import React from 'react'
import { Link } from 'gatsby'
import { Builder, withChildren, BuilderBlocks } from '@builder.io/react'

export default function GatsbyLink(props) {
    const { builderBlock, children, to, label } = props
    
    return (
        <Link
            to={to}
            style={{ 
                textDecoration: 'none',
                ...builderBlock?.responsiveStyles?.large,
            }}
            className={builderBlock?.class}
        >
            {label && label}
            {children && <BuilderBlocks blocks={children} />}
        </Link>
    )
}

Builder.registerComponent(withChildren(GatsbyLink), {
    noWrap: true,
    name: 'Gatsby Link',
    inputs: [
        {
            name: 'to',
            type: 'string',
        },
        {
            name: 'label',
            type: 'string',
            helperText: 'Link text only. Add children instead for icons.'
        }
    ]
})
